// import React, { FC } from 'react';
// import { useEffect } from 'react';
// import './stylesglobalpopup.css';
// import Modal from 'react-bootstrap/Modal';
// import EnquiryForm from 'src/views/HomeNew/PopupEnquiryForm';
// import CallNow from 'src/assets/img/call-now.svg';
// import GetAppIcon from '@material-ui/icons/GetApp';
// import LeftButtonIcon from 'src/assets/img/left_bt.svg';
// import { Helmet } from 'react-helmet';
// interface Props {
//     className?: any;
//     title?: any;
//     pagename?: any;

// }




// const GlobalPopupEnquiry: FC<Props> = ({ className, title, pagename, ...rest }) => {
//     const [modalShow, setModalShow] = React.useState(false);
//     useEffect(() => {
//   const preloadImg = new Image();
//   preloadImg.src = LeftButtonIcon;
// }, []);
//     function onChanges() {

//         setModalShow(false);
//     }

//     function MyVerticallyCenteredModal(props) {
//         return (
//             <Modal
//                 {...props}
//                 // size="lg"
//                 aria-labelledby="contained-modal-title-vcenter"
//                 centered
//                 id="enquiryformpopup"
//             >
//                 <Modal.Header closeButton className='close'>
                  
//                 </Modal.Header>
//                 <Modal.Body>
//                     <h4> {props.title == "Download Brochure" ? <GetAppIcon /> : ""}{props.title == "Submit" ? "Please fill in your details to receive your detailed rank prediction." : props.title}</h4>
//                     <div id="header-form" className="">
//                         <EnquiryForm onChanges={onChanges} page={props.pagename} />
//                     </div>
//                 </Modal.Body>
              
//             </Modal>
//         );
//     }


//     return (
//         <>
// <Helmet>
//   <link rel="preload" as="image" href={LeftButtonIcon} />
// </Helmet>

//             {pagename && pagename == 'CourseList' ?
//                 <a onClick={() => setModalShow(true)} className="talk-to-expert btn">
//                     <img src={CallNow} className="fcall" /> Talk to our Experts
//                 </a>
//                 :
//                 <>
//                     {
//                         pagename == 'Brochure' ?
//                             <a onClick={() => setModalShow(true)} className={className ? className : 'active_bt'}>
//                                 <img src={LeftButtonIcon} alt="Download Brochure" />

                                

//                             </a>
//                             :




//                             <a onClick={() => setModalShow(true)} className={className ? className : 'active_bt'} style={{ cursor: 'pointer' }}>
//                                 {title ? title : 'Apply Now'}
//                             </a>

//                     }
//                 </>
//             }

//             <MyVerticallyCenteredModal
//                 title={title ? title : 'Apply Now'}
//                 pagename={pagename ? pagename : 'no'}
//                 show={modalShow}
//                 onHide={() => setModalShow(false)}
//             />
//         </>
//     );
// };

// export default GlobalPopupEnquiry;
import React, { FC, useEffect } from 'react';
import './stylesglobalpopup.css';
import Modal from 'react-bootstrap/Modal';
import EnquiryForm from 'src/views/HomeNew/PopupEnquiryForm';
import CallNow from 'src/assets/img/call-now.svg';
import GetAppIcon from '@material-ui/icons/GetApp';
import { ReactComponent as LeftButtonIcon } from 'src/assets/img/left_bt.svg'; // Inline SVG for performance
import { Helmet } from 'react-helmet';

interface Props {
    className?: any;
    title?: any;
    pagename?: any;
}

const GlobalPopupEnquiry: FC<Props> = ({ className, title, pagename, ...rest }) => {
    const [modalShow, setModalShow] = React.useState(false);

    function onChanges() {
        setModalShow(false);
    }

    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                id="enquiryformpopup"
            >
                <Modal.Header closeButton className="close" />
                <Modal.Body>
                    <h4>
                        {props.title === "Download Brochure" && <GetAppIcon />}{" "}
                        {props.title === "Submit"
                            ? "Please fill in your details to receive your detailed rank prediction."
                            : props.title}
                    </h4>
                    <div id="header-form">
                        <EnquiryForm onChanges={onChanges} page={props.pagename} />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <>
            {/* Preload fallback (still helpful for browser hinting) */}
            <Helmet>
                <link rel="preload" as="image" href="/static/media/left_bt.a233c53e.svg" />
            </Helmet>

            {pagename && pagename === 'CourseList' ? (
                <a onClick={() => setModalShow(true)} className="talk-to-expert btn">
                    <img src={CallNow} className="fcall" loading="lazy" alt="Call now" />
                    Talk to our Experts
                </a>
            ) : (
                <>
                    {pagename === 'Brochure' ? (
                        <a
                            onClick={() => setModalShow(true)}
                            className={className ? className : 'active_bt'}
                        >
                            {/* Inline SVG with styling preserved via CSS class */}
                            <span className="left-icon">
                                <LeftButtonIcon className="svg-icon" aria-label="Download Brochure" />
                            </span>
                          
                        </a>
                    ) : (
                        <a
                            onClick={() => setModalShow(true)}
                            className={className ? className : 'active_bt'}
                            style={{ cursor: 'pointer' }}
                        >
                            {title ? title : 'Apply Now'}
                        </a>
                    )}
                </>
            )}

            <MyVerticallyCenteredModal
                title={title || 'Apply Now'}
                pagename={pagename || 'no'}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    );
};

export default GlobalPopupEnquiry;
